import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import SearchBars from 'components/SearchBars';
import Card from 'components/Card';
import { observer, inject } from 'mobx-react';
import TimesheetsTable, {
  TIMESHEET_COLUMNS, TIMESHEET_CARDS, TIMESHEET_MIN_TABLE_WIDTH
} from 'components/Tables/Timesheets';
import * as DataList from 'components/DataList';
import Sticky from 'react-stickynode';
import styled from '@emotion/styled';

const PageWrapGray = styled('div')`
  padding: 8px 12px;
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);
`

@inject('store', 'timesheetStore', 'viewStore') @observer
class TimesheetsIndexPage extends Component {

  render() {
    let content;
    const {
      props: {
        timesheetStore,
        viewStore,
        timesheetStore: {
          timelogs: {
            isLoading,
            isError
          }
        }
      }
    } = this;
    if (isLoading && !isError) {
      content = (
        <DataList.Loading
          columns={TIMESHEET_COLUMNS}
          cards={TIMESHEET_CARDS}
          minTableWidth={TIMESHEET_MIN_TABLE_WIDTH}
          noun="time entries"
        />
      );
    }
    if (isError && !isLoading) {
      content = <DataList.LoadError noun="time entries" onRetry={() => timesheetStore.loadTimelogs()} />;
    }
    if (!isError && !isLoading) {
      content = <TimesheetsTable />
    }
    return (
      <div>
        <PageWrapGray>
        <Sticky enabled={true} top={0} innerZ={9}>          
            <SearchBars.Timesheet key={viewStore.listFiltersVersion} />          
        </Sticky>
        <Helmet>
          <title>Timesheets | FieldNexus</title>
        </Helmet>
        
          <Card>
            {content}
          </Card>
        
        </PageWrapGray>
      </div>
    )
  }

};

export default TimesheetsIndexPage;